import { DirectiveOptions } from 'vue'

const registry = new Map<HTMLElement, AnyFn>()

document.addEventListener('click', (e) => {
  registry.forEach((callback, el) => {
    if (!el.contains(e.target as Node)) {
      callback()
    }
  })
})

const clickOutside: DirectiveOptions = {
  bind(el, binding) {
    if (typeof binding.value === 'function') {
      registry.set(el, binding.value)
    }
  },

  unbind(el) {
    registry.delete(el)
  },
}

export default clickOutside
